// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"c166ce970c40f9c45a6f","293":"842909a78f8a578881c5","518":"ccd244bbb2d29686167b","779":"b8968652e23820fddf7f"}[chunkId] + ".js";
};